export default function GetHighestNumber(dataCount) {
  let EUMeasures = 0;

  // If the query contains measures for EU, return the number.
  for (let i = 0; i < dataCount.length; i++) {
    if (dataCount[i].Countries === "European Union") {
      EUMeasures = dataCount[i]["nr_measures"];
    }
  }

  // Iterate, compare all the numbers to eachother and pick the highest, as a minimum '5' has been set as minimun maximum number (did you see what I did there?)
  let highest = 5;
  for (let i = 0; i < dataCount.length; i++) {
    let number = dataCount[i]["nr_measures"];
    highest = number > highest ? number : highest;
  }

  // Once the highest number has been determined, divided an array in five equal groups
  let arrayBorders = [];
  let groups = 5;
  let group = (highest + EUMeasures) / groups;

  for (let i = 1; i < groups + 1; i++) {
    let border = Math.ceil(i * group);
    arrayBorders.push(border);
  }
  // Return array with the borders to determine colours with
  return arrayBorders;
}
